export default "__VITE_ASSET__CtQ80UOW__"